import { render } from "./ProductReviewsComponent.vue?vue&type=template&id=168f7c12"
import script from "./ProductReviewsComponent.vue?vue&type=script&lang=js"
export * from "./ProductReviewsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/ProductReviewsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "168f7c12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('168f7c12', __exports__)) {
    api.reload('168f7c12', __exports__)
  }
  
  module.hot.accept("./ProductReviewsComponent.vue?vue&type=template&id=168f7c12", () => {
    api.rerender('168f7c12', render)
  })

}


export default __exports__